/* Financing lander only. Runs before ghost-lander.js (the loader section comes first). */
(function () {
  var fin = document.querySelector('.gl-fin');
  if (!fin) return;

  // Hero headline: the approved two lines. ghost-lander.js keeps pre-split lines and sizes them.
  var heading = document.querySelector('[id$="__ghost_hero"] .chero__heading');
  var lines = (fin.getAttribute('data-heading-lines') || '').split('|').filter(Boolean);
  if (heading && lines.length) {
    heading.classList.add('gl-head');
    heading.innerHTML = lines.map(function (l) { return '<span class="gl-ln gl-one">' + l.trim() + '</span>'; }).join(' ');
  }

  // Synchrony's prequalify and offers forms (their UniFi script, same one the product pages use).
  window.syfWidgetObject = { syfPartnerId: fin.getAttribute('data-partner-id'), flowType: 'PDP' };
  if (!document.getElementById('syfMPPScript')) {
    var s = document.createElement('script');
    s.id = 'syfMPPScript';
    s.async = true;
    s.src = 'https://pdpone.syfpos.com/mpp/UniFi.js';
    document.head.appendChild(s);
  }
  var amount = fin.getAttribute('data-amount') || '999';
  function open(fn, e) {
    if (window.syfMPP && typeof window.syfMPP[fn] === 'function') {
      e.preventDefault();
      try { window.syfMPP[fn](amount); } catch (err) { location.href = e.currentTarget.href; }
    }
  }
  function wire(el, fn) { if (el) el.addEventListener('click', function (e) { open(fn, e); }); }

  document.addEventListener('DOMContentLoaded', function () {
    wire(document.querySelector('[id$="__ghost_hero"] .chero__button--primary'), 'applyFromAnyWhere');
    wire(document.querySelector('[id$="__ghost_hero"] .chero__button--secondary'), 'mppFromAnyWhere');
    wire(document.querySelector('[id$="__ghost_sticky"] .scta__button'), 'applyFromAnyWhere');
    // Header button: ghost-lander.js makes it "Start my 45-day trial"; on this page it prequalifies.
    document.querySelectorAll('header a[href="/collections/frontpage"], .drawer a[href="/collections/frontpage"]').forEach(function (a) {
      if (!/Start my 45-day trial/.test(a.textContent)) return;
      a.href = '/products/harmony';
      var walker = document.createTreeWalker(a, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) {
        var n = walker.currentNode;
        if (/Start my 45-day trial/.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace('Start my 45-day trial', 'See if I prequalify');
      }
      a.querySelectorAll('[data-text]').forEach(function (el) {
        el.setAttribute('data-text', el.getAttribute('data-text').replace('Start my 45-day trial', 'See if I prequalify'));
      });
      wire(a, 'applyFromAnyWhere');
    });
  });
})();
